import { render, staticRenderFns } from "./ProfitItem.vue?vue&type=template&id=66db5221&scoped=true&"
import script from "./ProfitItem.vue?vue&type=script&lang=js&"
export * from "./ProfitItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66db5221",
  null
  
)

export default component.exports